(function () {
  if (window.__ottoMobilePreCartStatusInit) return;
  window.__ottoMobilePreCartStatusInit = true;

  var sectionId = 'mobile-pre-cart-status';
  var pendingTimer = null;
  var activeRequest = null;

  function roots() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-mobile-pre-cart-status]'));
  }

  function refresh() {
    if (!roots().length || activeRequest) return activeRequest;

    var url = new URL(window.location.href);
    url.searchParams.set('section_id', sectionId);
    activeRequest = fetch(url.toString(), { headers: { Accept: 'text/html' } })
      .then(function (response) {
        if (!response.ok) throw new Error('Mobile cart status refresh failed');
        return response.text();
      })
      .then(function (html) {
        var documentNode = new DOMParser().parseFromString(html, 'text/html');
        var freshStatus = documentNode.querySelector('[data-mobile-pre-cart-status]');
        if (!freshStatus) return;

        roots().forEach(function (root) {
          root.replaceWith(freshStatus.cloneNode(true));
        });
      })
      .catch(function () {
        // Existing server-rendered status remains visible if a refresh is unavailable.
      })
      .finally(function () {
        activeRequest = null;
      });

    return activeRequest;
  }

  function scheduleRefresh(delay) {
    window.clearTimeout(pendingTimer);
    pendingTimer = window.setTimeout(refresh, delay || 0);
  }

  document.addEventListener('DOMContentLoaded', function () {
    scheduleRefresh(0);
  });
  window.addEventListener('pageshow', function () {
    scheduleRefresh(0);
  });
  window.addEventListener('cart:updated', function () {
    scheduleRefresh(0);
  });
  window.addEventListener('cart:toggle', function () {
    scheduleRefresh(250);
  });
  document.addEventListener('shopify:section:load', function () {
    scheduleRefresh(0);
  });
})();
